<template>
    <v-stepper-content :step="step" class="text-center">
        <div>
            Siapkan bukti screenshot tag 3 teman atau follow Instagram <a href="http://instagram.com/medikoind" target="_blank">@medikoind</a> (Upload salah satu).
        </div>

        <div>
            Apabila mengalami kendala, kamu bisa menghubungi admin melalui line <admin-contact></admin-contact>.
        </div>

        <div class="mt-8">
            <v-btn
                @click="$emit('nextStep')"
                color="primary"
            >
                Selanjutnya
            </v-btn>
        </div>
    </v-stepper-content>
</template>

<script>
import AdminContact from '@/components/dashboard/payment/AdminContact'

export default {
    props: {
        step: {
            type: String
        }
    },
    components: {
        AdminContact,
    }
}
</script>
